export const NAME = 'BvConfig'
export const PROP_NAME = '$bvConfig'

export const DEFAULT_BREAKPOINT = ['xs', 'sm', 'md', 'lg', 'xl']
